import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "c-table__gakumonCheck" }
const _hoisted_2 = ["id", "ccnt", "lval"]
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "u-arrow-spOnlyBottom js-accordionArrow" }, null, -1)
const _hoisted_5 = ["id", "value", "pid", "lval"]
const _hoisted_6 = ["for"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsGakumon, (gakumon, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: gakumon[0].cls,
          class: _normalizeClass(gakumon[0].cls)
        }, [
          _createElementVNode("th", null, [
            _createElementVNode("input", {
              type: "checkbox",
              id: "chk_Gakumon"+index,
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateNextValues && _ctx.updateNextValues(...args))),
              ccnt: gakumon[0].gakka.length,
              lval: `${ gakumon[0].keitou }(すべて)`
            }, null, 40, _hoisted_2),
            _createElementVNode("label", {
              for: "chk_Gakumon"+index
            }, _toDisplayString(gakumon[0].keitou), 9, _hoisted_3),
            _hoisted_4
          ]),
          _createElementVNode("td", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gakumon[0].gakka, (gakka, number) => {
              return (_openBlock(), _createElementBlock("div", { key: number }, [
                _createElementVNode("input", {
                  id: "chk_Gakumon_"+index+"_gc"+number,
                  type: "checkbox",
                  value: gakumon[0].cd[number],
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args))),
                  name: "Gm",
                  pid: "chk_Gakumon"+index,
                  lval: `${ gakka }`
                }, null, 40, _hoisted_5),
                _createElementVNode("label", {
                  for: "chk_Gakumon_"+index+"_gc"+number
                }, [
                  _createTextVNode(_toDisplayString(gakka), 1),
                  (gakumon[0].cd[number] != 'gc400')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "./gakumon.html?cd="+gakumon[0].cd[number],
                        target: "_blank"
                      }, [
                        _createElementVNode("img", {
                          src: gakumon[0].imgPath,
                          alt: "学問分野解説"
                        }, null, 8, _hoisted_8)
                      ], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_6)
              ]))
            }), 128))
          ])
        ], 2))
      }), 128))
    ])
  ]))
}